import { Routes } from '@angular/router';
import { AuthGuard } from '../core/auth/guards/auth/auth.guard';
import { RoleGuard } from '../core/auth/guards/role/role.guard';
import { Roles } from '../core/enums/roles.enum';
import { DashboardContabilidadComponent } from './components/dashboard-contabilidad/dashboard-contabilidad.component';
import { GastoDetailComponent } from './components/gasto/gasto-detail/gasto-detail.component';
import { GastoFacturasNoProcesablesComponent } from './components/gasto/gasto-facturas-no-procesables/gasto-facturas-no-procesables.component';
import { GastoListComponent } from './components/gasto/gasto-list/gasto-list.component';
import { GastoNewComponent } from './components/gasto/gasto-new/gasto-new.component';
import { SepaDetailComponent } from './components/sepa/sepa-detail/sepa-detail.component';
import { SepaFacturasNoProcesablesComponent } from './components/sepa/sepa-facturas-no-procesables/sepa-facturas-no-procesables.component';
import { SepaListComponent } from './components/sepa/sepa-list/sepa-list.component';
import { SepaNewComponent } from './components/sepa/sepa-new/sepa-new.component';
import { VentaDetailComponent } from './components/venta/venta-detail/venta-detail.component';
import { VentaListComponent } from './components/venta/venta-list/venta-list.component';
import { VentaNewComponent } from './components/venta/venta-new/venta-new.component';
import CodigosArticulosGastosComponent from './maestros/components/gastos-codigos-articulos/gastos-codigos-articulos.component';
import DashboardContabilidadMaestrosComponent from './maestros/dashboard/dashboard.component';

export const CONTABILIDAD_ONDA_ROUTES: Routes = [
  {
    path: '',
    component: DashboardContabilidadComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'gastos',
    component: GastoListComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'gastos/facturas-no-procesables',
    component: GastoFacturasNoProcesablesComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'gastos/nuevo',
    component: GastoNewComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'gastos/:id',
    component: GastoDetailComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'sepa',
    component: SepaListComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'sepa/facturas-no-procesables',
    component: SepaFacturasNoProcesablesComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'sepa/nuevo',
    component: SepaNewComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'sepa/:id',
    component: SepaDetailComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'ventas',
    component: VentaListComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'ventas/nuevo',
    component: VentaNewComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'ventas/:id',
    component: VentaDetailComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'contabilidad-maestros',
    component: DashboardContabilidadMaestrosComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
  {
    path: 'contabilidad-maestros/gastos-codigos-articulos',
    component: CodigosArticulosGastosComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [Roles.SuperAdmin, Roles.Contable] },
  },
];
